import axiosInstance from "@/services/https/global";
import axios from "axios";
import CONFIG from "@/config";
const baseUrl = `${CONFIG.BASE_URL}/wayapay-settlement-service/api/v1`;

export const getGlAccounts = async (params = {}) => {
  const queryParams = {};
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();
  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;

  try {
    const response = await axiosInstance.get(`${baseUrl}/gl/accounts`, {
      params: queryParams,
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }

    throw new Error("An unexpected error occurred");
  }
};

export const createGlAccount = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/gl/accounts`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const updateGlAccount = async ({ id, ...payload }) => {
  try {
    const response = await axiosInstance.put(
      `${baseUrl}/gl/accounts/${id}`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getGlAccount = async ({ glId }) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/gl/accounts/${glId}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getGlAccountWithBalance = async ({ glId }) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/gl/accounts/${glId}/with-balance`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getGlAccountLedger = async (glId, params = {}) => {
  const queryParams = {};

  if (params.search?.trim()) queryParams.search = params.search.trim();
  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.fromDate) queryParams.fromDate = params.fromDate;
  if (params.toDate) queryParams.toDate = params.toDate;
  if (params.direction) queryParams.direction = params.direction;

  try {
    const response = await axiosInstance.get(
      `${baseUrl}/gl/accounts/${glId}/ledger`,
      { params: queryParams },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getGlJournalEntries = async (params = {}) => {
  const queryParams = {};
  if (params.search?.trim()) queryParams.search = params.search.trim();
  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.fromDate) queryParams.fromDate = params.fromDate;
  if (params.toDate) queryParams.toDate = params.toDate;
  if (params.eventType) queryParams.eventType = params.eventType;

  try {
    const response = await axiosInstance.get(`${baseUrl}/gl/journal-entries`, {
      params: queryParams,
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }

    throw new Error("An unexpected error occurred");
  }
};
